module.exports = __webpack_public_path__ + "img/0003.7ed1b8e2.jpg";